/* global axios */
import ApiClient from './ApiClient';

class CortexSettingsAPI extends ApiClient {
  constructor() {
    super('cortex/settings', { accountScoped: true });
  }

  update(settings) {
    return axios.patch(this.url, { settings });
  }
}

export default new CortexSettingsAPI();
